import SiteRepo from "./SiteRepo";
import {Site} from "../../../models/ti/Site";
import {ListQuery} from "../../CrudRepo";

export class InMemorySiteRepoCache implements SiteRepo {
    cachedSiteList?: Site[];
    sitePromise?: Promise<Site[]>;
    
    constructor(private inner: SiteRepo) {}

    async listAll(): Promise<Site[]> {
        if (this.cachedSiteList) {
            return this.cachedSiteList;
        } else {
            if (this.sitePromise) {
                return this.sitePromise;
            } else {
                const sitesPromise = this.inner.listAll();
                this.sitePromise = sitesPromise;
                const sites = await sitesPromise;
                this.cachedSiteList = sites;
                this.sitePromise = undefined;
                return sites;
            }
        }
    };

    create = (resource: Partial<Site>) => {
        this.cachedSiteList = undefined;
        return this.inner.create(resource)
    };

    delete = (id: string) => {
        this.cachedSiteList = undefined;
        return this.inner.delete(id);
    };

    getById = (id: string) => this.inner.getById(id);

    list = (query: ListQuery) => this.inner.list(query);

    update = (id: string, resource: Partial<Site>) => {
        this.cachedSiteList = undefined;
        return this.inner.update(id, resource);
    };

    listAvailableTopicsForSiteById = this.inner.listAvailableTopicsForSiteById;

    createTopicForSiteById = this.inner.createTopicForSiteById;

    updateTopicForSiteById = this.inner.updateTopicForSiteById;

    deleteTopicForSiteById = this.inner.deleteTopicForSiteById;
}